import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FavoriteStar from "./FavoriteStar";
import ChannelStatusMenu from "./ChannelStatusMenu";
import LinkAbrirDetalhes from "./LinkAbrirDetalhes";
import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import {
  desfavoritarProcessByEmail,
  favoritarProcessByEmail,
} from "../services/clientService";
import { useUserStore } from "../store/userStore";
import { toast } from "react-toastify";
import { useProcessStore } from "../store/useProcessStore";

interface ProcessTablesProps {
  list: any;
  loadMoreData: () => void;
  isLoading: boolean;
  reloadData: any;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#326AFD",
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const CustomizedTables: React.FC<ProcessTablesProps> = (
  props: ProcessTablesProps
) => {
  const tableContainerRef = React.useRef<HTMLDivElement>(null);
  const currentUserEmail = useUserStore((state) => state.email);
  const token = useUserStore((state) => state.idToken);
  const { reloadFlag, toggleReload } = useProcessStore();

  const handleFavoritar = async (codigo: string, isCurrentlyFav: boolean) => {
    const email = currentUserEmail;

    try {
      if (!isCurrentlyFav) {
        await favoritarProcessByEmail(codigo, email, token);
        toast.success("Processo favoritado com sucesso!");
      } else {
        await desfavoritarProcessByEmail(codigo, email);
        toast.success("Processo desfavoritado com sucesso!");
      }

      toggleReload();
      props.reloadData();
    } catch (error: any) {
      console.error("Erro:", error.response?.data || error.message);
      toast.error("Erro ao atualizar favoritos.");
    }
  };

  const handleScroll = () => {
    if (tableContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        tableContainerRef.current;
      if (scrollHeight - scrollTop <= clientHeight + 50) {
        props.loadMoreData();
      }
    }
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const { scrollHeight, clientHeight } = container;
      if (
        scrollHeight <= clientHeight &&
        props.list.length > 0 &&
        !props.isLoading
      ) {
        props.loadMoreData();
      }
    }
  }, [props.list, props.isLoading]);

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ borderRadius: "17px", height: "90%" }}
        ref={tableContainerRef}
        onScroll={handleScroll}
      >
        <Table sx={{ minWidth: 600 }} aria-label="customized table">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="center"></StyledTableCell>
              <StyledTableCell align="center">REF</StyledTableCell>
              <StyledTableCell align="center">Nº DI</StyledTableCell>
              <StyledTableCell align="center">Nº INVOICE</StyledTableCell>
              <StyledTableCell align="center">B/L</StyledTableCell>
              <StyledTableCell align="center">CONTAINER</StyledTableCell>
              <StyledTableCell align="center">CANAL</StyledTableCell>
              <StyledTableCell align="center">STATUS</StyledTableCell>
              <StyledTableCell align="center">DETALHES</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(props.list) &&
              props.list.map((row: any) => {
                const userEmails = row.clientes ?? [];
                const isUserLinked = userEmails.includes(currentUserEmail);

                return (
                  <StyledTableRow key={row.CD_PROCESSO}>
                    <StyledTableCell
                      component="th"
                      scope="row"
                      align="center"
                      sx={{ padding: "9px !important" }}
                    >
                      <FavoriteStar
                        checked={isUserLinked}
                        onClick={() =>
                          handleFavoritar(row.CD_PROCESSO, isUserLinked)
                        }
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.CD_PROCESSO}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.NR_DI}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.NR_DOC_INSTR ?? "--"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.NR_DOC_CARGA}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.NR_CONTAINER && row.NR_CONTAINER.length > 0
                        ? row.NR_CONTAINER[0]
                        : "--"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {<ChannelStatusMenu status={row.CANAL} />}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.HISTORICO_RESUMO?.INF_HISTORICO ?? "--"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <LinkAbrirDetalhes item={row} />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
        {props.isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "10px",
            }}
          >
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress
                size={48}
                thickness={4}
                style={{ color: "#326AFD" }}
              />
            </Box>
          </div>
        )}
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 15]}
        component="div"
        count={props.list.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Linhas por página"
      /> */}
    </>
  );
};

export default CustomizedTables;
